import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useCRM } from '../context/CRMContext';
import Payslip from '../components/Payroll/Payslip';
import LoadingSpinner from '../components/UI/LoadingSpinner';
import Button from '../components/UI/Button';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPrinter } = FiIcons;

const PrintPayslip = () => {
  const { id } = useParams();
  const { payrollRecords, users, loading } = useCRM();
  const [record, setRecord] = useState(null);
  const [user, setUser] = useState(null);
  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    // Only proceed if data is loaded or if we have records available
    if ((!loading && payrollRecords.length > 0) || payrollRecords.length > 0) {
      const foundRecord = payrollRecords.find(r => r.id === id);
      if (foundRecord) {
        setRecord(foundRecord);
        const foundUser = users.find(u => u.id === foundRecord.userId);
        setUser(foundUser);
      }
      setDataLoaded(true);
    }
  }, [id, payrollRecords, users, loading]);

  if (loading && !dataLoaded) return <div className="flex p-10 justify-center"><LoadingSpinner /></div>;
  if (!record) return <div className="p-10 text-center">Payslip not found or loading...</div>;

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      {/* No-print controls */}
      <div className="max-w-3xl mx-auto mb-6 flex justify-end print:hidden">
        <Button onClick={handlePrint}>
          <SafeIcon icon={FiPrinter} className="h-4 w-4 mr-2" />
          Print / Save as PDF
        </Button>
      </div>
      
      <Payslip record={record} user={user} />
      
      <style>{`
        @media print {
          body {
            background-color: white;
          }
          .print\\:hidden {
            display: none !important;
          }
          /* Reset margins for print */
          @page {
            margin: 0;
          }
          body {
            margin: 1.6cm;
          }
        }
      `}</style>
    </div>
  );
};

export default PrintPayslip;